export default __webpack_public_path__ + "static/media/icons8-menu-100.46cde05a.svg";